import { formaters } from "vincent-utils";
const getHeightMultiplier = function (duréeMiniRdv) {
    return duréeMiniRdv < 15 ? 1.2 / 10 : 1 / 10;
};
const getUniqueId = function (rdv) {
    return ((rdv.tag === "rdv" ? "rdv" : "case") +
        "_" +
        rdv.date.getDate() +
        "_" +
        (rdv.date.getMonth() + 1) +
        "_" +
        rdv.date.getFullYear() +
        "_" +
        rdv.hour +
        "_" +
        rdv.minute);
};
const generateClosedDay = function (date, displayStart, displayEnd) {
    "use strict";
    const heure = formaters.getHeureMinuteObjectFromHeureEnMinutes(displayStart)?.heure;
    if (typeof heure !== "number") {
        throw new Error("heure is not a number in generateClosedDay");
    }
    const minute = formaters.getHeureMinuteObjectFromHeureEnMinutes(displayStart)?.minute;
    if (typeof minute !== "number") {
        throw new Error("minute is not a number in generateClosedDay");
    }
    const closedRdv = {
        duration: displayEnd - displayStart,
        type: 29,
        objet: "Jour Fermé (horaires)",
        date,
        hour: heure,
        minute,
        tag: "closedByHoraire",
    };
    return [closedRdv];
};
const dayClosedReplacer = function (dayRdvs, date, displayStart, displayEnd) {
    "use strict";
    //si dayRdvs est empty, la journée est fermée par les horaires
    const resultArray = dayRdvs.length > 0
        ? [...dayRdvs]
        : generateClosedDay(date, displayStart, displayEnd);
    return resultArray;
};
export { dayClosedReplacer, getHeightMultiplier, getUniqueId };
//# sourceMappingURL=dayClosedReplacer.js.map